import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";

import Card from "components/Card/Card.js";

import { checkTimetableMenuTypeNew } from "util/menuUtils.js";

import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

const useStyles = makeStyles(menuStyle);

export default function BaseMenuTypeTimetable(props) {
  const {
    restaurant,
    shippingInfo,
    language,
    updateShippingInfo
    // updateCart
  } = props;
  // const menu = restaurant.menus[0];
  const classes = useStyles();

  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  function handleClick(value) {
    const timetable = timetableArray.find(el => el.label_it === value);
    const copyShippingInfo = Object.assign({}, shippingInfo, {
      timetable
    });
    updateShippingInfo(copyShippingInfo);
  }

  const toggleDrawer = (anchor, open) => () => {
    setOpen(open);
  };

  // const timetableArray = checkTimetableMenuType(restaurant);

  const timetableArray = checkTimetableMenuTypeNew(restaurant);

  if (timetableArray && timetableArray.length > 0) {
    return (
      <Card>
        <div style={{ paddingRight: "20px" }}>
          <div className={classes.containerLeft}>
            <span
              style={{
                lineHeight: "40px",
                paddingLeft: "10px"
              }}
            >
              <span className={classes.span}>{t("menuList.timetable")}</span>
            </span>
          </div>
          <div className={classes.containerRight}>
            {/* ******* WEB >= 960 ********** */}
            <Hidden smDown implementation="css">
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select
                }}
                value={
                  shippingInfo &&
                  shippingInfo.timetable &&
                  shippingInfo.timetable.label_it
                    ? shippingInfo.timetable.label_it
                    : ""
                }
                onChange={e => handleClick(e.target.value)}
                style={{
                  fontFamily: "'Archivo Narrow', sans-serif",
                  margin: "0px"
                }}
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select"
                }}
              >
                {timetableArray.map((el, index) => (
                  <MenuItem
                    key={`${el.label_it}_${index.toString()}`}
                    value={el.label_it}
                  >
                    {el[`label_${language}`]}
                  </MenuItem>
                ))}
              </Select>
            </Hidden>
            {/* ******* MOBILE < 960 ********** */}
            <Hidden mdUp implementation="css">
              <div
                style={{
                  textAlign: "right",
                  lineHeight: "55px"
                }}
              >
                <Button
                  style={{ minWidth: "20px" }}
                  onClick={toggleDrawer("bottom", true)}
                >
                  {shippingInfo &&
                  shippingInfo.timetable &&
                  shippingInfo.timetable[`label_${language}`]
                    ? shippingInfo.timetable[`label_${language}`]
                    : ""}
                </Button>
                <SwipeableDrawer
                  style={{ zIndex: 9999 }}
                  anchor={"bottom"}
                  open={open}
                  onClose={toggleDrawer("bottom", false)}
                  onOpen={toggleDrawer("bottom", true)}
                >
                  <List>
                    {timetableArray.map(text => (
                      <ListItem
                        onClick={() => {
                          handleClick(text.label_it);
                          setOpen(false);
                        }}
                        button
                        style={{ backgroundColor: "transparent" }}
                        key={text.label_it}
                      >
                        <ListItemText primary={text[`label_${language}`]} />
                      </ListItem>
                    ))}
                  </List>
                </SwipeableDrawer>
              </div>
            </Hidden>
          </div>
        </div>
      </Card>
    );
  } else {
    return null;
  }
}

BaseMenuTypeTimetable.propTypes = {
  // menu: PropTypes.arrayOf(PropTypes.object),
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    timetable: PropTypes.object
  }).isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
  updateCart: PropTypes.func.isRequired
};

BaseMenuTypeTimetable.defaultProps = {
  // menu: null
};
